<template>
  <div class="position-relative">
    <b-row align-v="center" no-gutters id="subheader">
      <b-col cols="auto" class="p-0">
        <!-- Logo -->
        <a href="/" target="_top" @click.prevent="handleLogoClick">
          <div class="py-2 px-2 bg-aba-primary h-100">
            <img :src="require('@/assets/img/logo-ABA.svg')" alt="ABA" class="img img-fluid logo-header" />
          </div>
        </a>
        <!-- /Logo -->
      </b-col>
      <b-col cols="auto" class="position-static">
        <nav class="main-nav d-none d-md-inline-block">
          <ul class="main-nav-list list-unstyled">
            <li class="main-nav-item sub">
              <div class="main-nav-link-wrapper">
                <a target="_blank" href="https://www.workinaustria.com/warum-oesterreich" tabindex="0" class="main-nav-link" aria-current="page">
                  Warum Österreich
                  <div class="main-nav-link-toggle-desktop d-none d-lg-inline-block">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-navigation">
                      <path d="M15.5,5.9,9.88,11.59a2.63,2.63,0,0,1-3.76,0L.5,5.9,2.75,3.62,8,8.93l5.25-5.3Z" style="fill-rule: evenodd"></path>
                    </svg>
                    <span class="sr-only">Toggle sub navigation</span>
                  </div>
                </a>
                <div tabindex="0" class="main-nav-link-toggle">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-navigation">
                    <path d="M15.5,5.9,9.88,11.59a2.63,2.63,0,0,1-3.76,0L.5,5.9,2.75,3.62,8,8.93l5.25-5.3Z" style="fill-rule: evenodd"></path>
                  </svg>
                  <span class="sr-only">Toggle sub navigation</span>
                </div>
              </div>
              <div class="main-sub-nav-wrapper main-sub-nav-wrapper--false">
                <nav class="main-sub-nav main-sub-nav--false">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="container-lg">
                        <div class="main-sub-nav-mobile-header">
                          <div class="main-sub-nav-mobile-header-back">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-navigation">
                              <path
                                d="M15.5,5.9,9.88,11.59a2.63,2.63,0,0,1-3.76,0L.5,5.9,2.75,3.62,8,8.93l5.25-5.3Z"
                                style="fill-rule: evenodd"
                              ></path>
                            </svg>
                            <span class="sr-only">Toggle sub navigation</span>
                          </div>
                          <a
                            target="_blank"
                            href="https://www.workinaustria.com/warum-oesterreich"
                            class="h4 main-sub-nav-mobile-header-link nuxt-link-exact-active nuxt-link-active"
                            aria-current="page"
                          >
                            Warum Österreich
                          </a>
                        </div>
                        <span class="d-none d-lg-inline-block tag mb-1-half">Warum Österreich</span>
                        <div id="sub-nav-item-99" class="sub-nav-guide-category-item">
                          <div class="row">
                            <div class="col-lg-2">
                              <div class="sub-nav-guide-link-wrapper">
                                <a
                                  target="_blank"
                                  href="https://www.workinaustria.com/warum-oesterreich/lebensqualitaet-in-oesterreich"
                                  class="sub-nav-guide-link"
                                  ><span class="sub-nav-guide-link-title">Lebensqualität</span>
                                </a>
                              </div>
                            </div>
                            <div class="col-lg-2">
                              <div class="sub-nav-guide-link-wrapper">
                                <a
                                  target="_blank"
                                  href="https://www.workinaustria.com/warum-oesterreich/innovativer-arbeitsstandort"
                                  class="sub-nav-guide-link"
                                  ><span class="sub-nav-guide-link-title">Arbeitsstandort</span>
                                </a>
                              </div>
                            </div>
                            <div class="col-lg-2">
                              <div class="sub-nav-guide-link-wrapper">
                                <a
                                  target="_blank"
                                  href="https://www.workinaustria.com/warum-oesterreich/gehaltsniveau-in-oesterreich"
                                  class="sub-nav-guide-link"
                                  ><span class="sub-nav-guide-link-title">Gehaltsniveau</span>
                                </a>
                              </div>
                            </div>
                            <div class="col-lg-2">
                              <div class="sub-nav-guide-link-wrapper">
                                <a
                                  target="_blank"
                                  href="https://www.workinaustria.com/warum-oesterreich/lage-im-zentrum-europas"
                                  class="sub-nav-guide-link"
                                  ><span class="sub-nav-guide-link-title">Zentrale Lage</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
            </li>
            <li class="main-nav-item sub">
              <div class="main-nav-link-wrapper">
                <a target="_blank" href="https://www.workinaustria.com/aufenthalt-beschaeftigung" tabindex="0" class="main-nav-link">
                  Aufenthalt &amp; Beschäftigung

                  <div class="main-nav-link-toggle-desktop d-none d-lg-inline-block">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-navigation">
                      <path d="M15.5,5.9,9.88,11.59a2.63,2.63,0,0,1-3.76,0L.5,5.9,2.75,3.62,8,8.93l5.25-5.3Z" style="fill-rule: evenodd"></path>
                    </svg>
                    <span class="sr-only">Toggle sub navigation</span>
                  </div>
                </a>
                <div tabindex="0" class="main-nav-link-toggle">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-navigation">
                    <path d="M15.5,5.9,9.88,11.59a2.63,2.63,0,0,1-3.76,0L.5,5.9,2.75,3.62,8,8.93l5.25-5.3Z" style="fill-rule: evenodd"></path>
                  </svg>
                  <span class="sr-only">Toggle sub navigation</span>
                </div>
              </div>
              <div class="main-sub-nav-wrapper main-sub-nav-wrapper--guide">
                <nav class="main-sub-nav main-sub-nav--guide">
                  <!---->
                  <div class="container-fluid">
                    <div class="row">
                      <div page-type="guide" class="container-fluid">
                        <div class="main-sub-nav-mobile-header">
                          <div class="main-sub-nav-mobile-header-back">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-navigation">
                              <path
                                d="M15.5,5.9,9.88,11.59a2.63,2.63,0,0,1-3.76,0L.5,5.9,2.75,3.62,8,8.93l5.25-5.3Z"
                                style="fill-rule: evenodd"
                              ></path>
                            </svg>
                            <span class="sr-only">Toggle sub navigation</span>
                          </div>
                          <a
                            href="https://www.workinaustria.com/aufenthalt-beschaeftigung"
                            target="_blank"
                            class="h4 main-sub-nav-mobile-header-link"
                          >
                            Aufenthalt &amp; Beschäftigung
                          </a>
                        </div>
                        <div class="row">
                          <div class="sub-nav-guide-category-col pl-0 pl-lg-t-q more-than-7 col-lg-8 mb-1-half mb-xl-0">
                            <div id="sub-nav-item-1219" data-id="1219" class="sub-nav-guide-category-item">
                              <span class="tag">Aufenthalt &amp; Beschäftigung</span>
                              <div class="row">
                                <div class="col-lg-6 col-xl-4">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/aufenthalt-beschaeftigung/rot-weiss-rot-karte"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Rot-Weiß-Rot – Karte</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-lg-6 col-xl-4">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/aufenthalt-beschaeftigung/rot-weiss-rot-karte-plus"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Rot-Weiß-Rot – Karte Plus</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-lg-6 col-xl-4">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/aufenthalt-beschaeftigung/blaue-karte-eu"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Blaue Karte EU</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-lg-6 col-xl-4">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/aufenthalt-beschaeftigung/daueraufenthalt-eu"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Daueraufenthalt EU</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-lg-6 col-xl-4">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/aufenthalt-beschaeftigung/niederlassungsbewilligung"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Niederlassungsbewilligung</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-lg-6 col-xl-4">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/aufenthalt-beschaeftigung/aufenthaltstitel-fuer-selbststaendige"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Aufenthaltstitel für Selbstständige</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-lg-6 col-xl-4">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/aufenthalt-beschaeftigung/temporaerer-aufenthalt-mit-aufenthaltsbewilligung"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Temporärer Aufenthalt mit Aufenthaltsbewilligung</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-lg-6 col-xl-4">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/aufenthalt-beschaeftigung/studierende-forscher-kuenstler"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Studierende, Forscher und Künstler</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-lg-6 col-xl-4">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/aufenthalt-beschaeftigung/aufenthaltsrecht-fuer-ewr-buergerinnen-in-oesterreich"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Aufenthaltsrecht für EWR/EU-Bürger:innen in Österreich</span></a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="sub-nav-guide-category-col pl-0 pl-lg-t-q col-lg-4">
                            <div id="sub-nav-item-1220" data-id="1220" class="sub-nav-guide-category-item">
                              <span class="tag opacity-0">Sonstiges</span>
                              <div class="row">
                                <div class="col-12">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/aufenthalt-beschaeftigung/aufenthaltstitel-fuer-drittstaatsangehoerige-in-oesterreich"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Aufenthaltsrecht im Überblick</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      href="/aufenthalt-beschaeftigung/verlaengerung-des-aufenthaltstitels-in-oesterreich"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Verlängerung des Aufenthaltstitels in Österreich</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/aufenthalt-beschaeftigung/familienzusammenfuehrung"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Familienzusammenführung</span></a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!---->
                    </div>
                  </div>
                </nav>
              </div>
            </li>
            <li class="main-nav-item sub">
              <div class="main-nav-link-wrapper">
                <a target="_blank" href="https://www.workinaustria.com/leben-arbeiten" tabindex="0" class="main-nav-link">
                  Leben &amp; Arbeiten

                  <div class="main-nav-link-toggle-desktop d-none d-lg-inline-block">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-navigation">
                      <path d="M15.5,5.9,9.88,11.59a2.63,2.63,0,0,1-3.76,0L.5,5.9,2.75,3.62,8,8.93l5.25-5.3Z" style="fill-rule: evenodd"></path>
                    </svg>
                    <span class="sr-only">Toggle sub navigation</span>
                  </div>
                </a>
                <div tabindex="0" class="main-nav-link-toggle">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-navigation">
                    <path d="M15.5,5.9,9.88,11.59a2.63,2.63,0,0,1-3.76,0L.5,5.9,2.75,3.62,8,8.93l5.25-5.3Z" style="fill-rule: evenodd"></path>
                  </svg>
                  <span class="sr-only">Toggle sub navigation</span>
                </div>
              </div>
              <div class="main-sub-nav-wrapper main-sub-nav-wrapper--guide">
                <nav class="main-sub-nav main-sub-nav--guide">
                  <!---->
                  <div class="container-fluid">
                    <div class="row">
                      <div page-type="guide" class="container-fluid">
                        <div class="main-sub-nav-mobile-header">
                          <div class="main-sub-nav-mobile-header-back">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-navigation">
                              <path
                                d="M15.5,5.9,9.88,11.59a2.63,2.63,0,0,1-3.76,0L.5,5.9,2.75,3.62,8,8.93l5.25-5.3Z"
                                style="fill-rule: evenodd"
                              ></path>
                            </svg>
                            <span class="sr-only">Toggle sub navigation</span>
                          </div>
                          <a target="_blank" href="https://www.workinaustria.com/leben-arbeiten" class="h4 main-sub-nav-mobile-header-link">
                            Leben &amp; Arbeiten
                          </a>
                        </div>
                        <div class="row">
                          <div class="sub-nav-guide-category-col pl-0 pl-lg-t-q more-than-4 col-lg-8 mb-1-half mb-xl-0">
                            <div id="sub-nav-item-1208" data-id="1208" class="sub-nav-guide-category-item">
                              <span class="tag">Leben &amp; Arbeiten</span>
                              <div class="row">
                                <div class="col-lg-6">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/leben-arbeiten/sozial-und-gesundheitssystem-in-oesterreich"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Sozial- &amp; Gesundheitssystem in Österreich</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-lg-6">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/leben-arbeiten/kompetenzfeststellung"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Kompetenzfeststellung</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-lg-6">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/leben-arbeiten/jobsuche-in-oesterreich"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Jobsuche in Österreich</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-lg-6">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/leben-arbeiten/deutschkenntnisse"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Deutschkenntnisse</span></a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="sub-nav-guide-category-col pl-0 pl-lg-t-q col-lg-4">
                            <div id="sub-nav-item-1209" data-id="1209" class="sub-nav-guide-category-item">
                              <span class="tag opacity-0">Besondere Zielgruppen</span>
                              <div class="row">
                                <div class="col-12">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a target="_blank" href="https://www.workinaustria.com/willkommen-daheim" tabindex="0" class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Auslandsösterreicher:innen</span></a
                                    >
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="sub-nav-guide-link-wrapper">
                                    <a
                                      target="_blank"
                                      href="https://www.workinaustria.com/internationale-studierende"
                                      tabindex="0"
                                      class="sub-nav-guide-link"
                                      ><span class="sub-nav-guide-link-title">Internationale Studierende</span></a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!---->
                    </div>
                  </div>
                </nav>
              </div>
            </li>
            <li class="main-nav-item sub">
              <div class="main-nav-link-wrapper">
                <a href="https://www.workinaustria.com/unsere-services" tabindex="0" class="main-nav-link">
                  Unsere Services
                  <div class="main-nav-link-toggle-desktop d-none d-lg-inline-block">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-navigation">
                      <path d="M15.5,5.9,9.88,11.59a2.63,2.63,0,0,1-3.76,0L.5,5.9,2.75,3.62,8,8.93l5.25-5.3Z" style="fill-rule: evenodd"></path>
                    </svg>
                    <span class="sr-only">Toggle sub navigation</span>
                  </div>
                </a>
                <div tabindex="0" class="main-nav-link-toggle">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-navigation">
                    <path d="M15.5,5.9,9.88,11.59a2.63,2.63,0,0,1-3.76,0L.5,5.9,2.75,3.62,8,8.93l5.25-5.3Z" style="fill-rule: evenodd"></path>
                  </svg>
                  <span class="sr-only">Toggle sub navigation</span>
                </div>
              </div>
              <div class="main-sub-nav-wrapper main-sub-nav-wrapper--business">
                <nav class="main-sub-nav main-sub-nav--business">
                  <div>
                    <div class="main-sub-nav-mobile-header">
                      <div class="main-sub-nav-mobile-header-back">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-navigation">
                          <path d="M15.5,5.9,9.88,11.59a2.63,2.63,0,0,1-3.76,0L.5,5.9,2.75,3.62,8,8.93l5.25-5.3Z" style="fill-rule: evenodd"></path>
                        </svg>
                        <span class="sr-only">Toggle sub navigation</span>
                      </div>
                      <a target="_blank" href="https://www.workinaustria.com/unsere-services" class="h4 main-sub-nav-mobile-header-link">
                        Unsere Services
                      </a>
                    </div>
                    <div class="row">
                      <div class="col-lg-4 sub-nav-business-nav-col">
                        <div class="sub-nav-business-item">
                          <a
                            target="_blank"
                            href="https://www.workinaustria.com/unsere-services/services-fuer-arbeitgeber"
                            tabindex="0"
                            class="sub-nav-business-link"
                          >
                            <div>
                              <div>
                                <span class="tag d-inline-flex align-items-center"
                                  ><!---->
                                  Unsere Services
                                </span>
                              </div>
                              <span class="h2 mb-1 mb-lg-1-half d-inline-block">Services für Arbeitgeber:innen</span>
                            </div>
                            <span class="link d-block"
                              >Mehr erfahren
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-next">
                                <path
                                  d="M14.82,6.41l-5-4.84L8.24,3.16,12,6.87H.5V9.13H12l-3.8,3.71,1.63,1.59,5-4.84A2.19,2.19,0,0,0,14.82,6.41Z"
                                  style="fill-rule: evenodd"
                                ></path>
                              </svg>
                            </span>
                          </a>
                        </div>
                      </div>
                      <div class="col-lg-4 sub-nav-business-nav-col">
                        <div class="sub-nav-business-item">
                          <a
                            target="_blank"
                            href="https://www.workinaustria.com/unsere-services/services-fuer-fachkraefte"
                            tabindex="0"
                            class="sub-nav-business-link"
                          >
                            <div>
                              <div>
                                <span class="tag d-inline-flex align-items-center"
                                  ><!---->
                                  Unsere Services
                                </span>
                              </div>
                              <span class="h2 mb-1 mb-lg-1-half d-inline-block">Services für Fachkräfte</span>
                            </div>
                            <span class="link d-block"
                              >Mehr erfahren
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-next">
                                <path
                                  d="M14.82,6.41l-5-4.84L8.24,3.16,12,6.87H.5V9.13H12l-3.8,3.71,1.63,1.59,5-4.84A2.19,2.19,0,0,0,14.82,6.41Z"
                                  style="fill-rule: evenodd"
                                ></path>
                              </svg>
                            </span>
                          </a>
                        </div>
                      </div>
                      <div class="col-lg-4 sub-nav-business-nav-col">
                        <div class="sub-nav-business-item">
                          <a target="_blank" href="https://www.workinaustria.com/unsere-services/ueber-uns" class="sub-nav-business-link">
                            <div>
                              <div>
                                <span class="tag d-inline-flex align-items-center"
                                  ><!---->
                                  Unsere Services
                                </span>
                              </div>
                              <span class="h2 mb-1 mb-lg-1-half d-inline-block">Über uns</span>
                            </div>
                            <span class="link d-block"
                              >Mehr erfahren
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-arrow-next">
                                <path
                                  d="M14.82,6.41l-5-4.84L8.24,3.16,12,6.87H.5V9.13H12l-3.8,3.71,1.63,1.59,5-4.84A2.19,2.19,0,0,0,14.82,6.41Z"
                                  style="fill-rule: evenodd"
                                ></path>
                              </svg>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!---->
                </nav>
              </div>
            </li>
          </ul>
        </nav>
      </b-col>
      <b-col cols="auto" class="d-none d-md-flex ml-auto">
        <a
          href="https://immigration-guide.workinaustria.com/de/"
          target="_blank"
          rel="noopener"
          class="btn btn-tertiary header-btn-get-in-touch btn-sm d-none d-lg-block m-0 ml-half"
        >
          Immigration Guide
        </a>
      </b-col>
      <b-col cols="auto" class="d-none d-md-flex mr-3">
        <language-header />
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import LanguageHeader from '@/components/Header/LanguageHeader.vue';
import { AppModule } from '@/store/modules/app';

@Component({
  components: {
    LanguageHeader,
  },
})
export default class InformationNavigation extends Vue {
  handleLogoClick() {
    if (this.$route.path === '/') {
      window.location.href = '/';
    } else {
      this.$router.push({ path: '/' }).catch(() => {});
    }
  }
}
</script>
<style scoped lang="scss">
.main-nav-list {
  background: #f6f9fb;
  padding: 0 0 0 3rem;
  margin: 0;
}
</style>
